export default __webpack_public_path__ + "static/media/not-found-md.bae383a0.png";